/* eslint-disable angular/function-type */

import angular from 'angular';
import pRetry from 'p-retry';

/**
 * @ngdoc service
 * @name app.Agent
 * @description
 * # Agent
 * Service in the app.
 */
angular.module('app')
	.service('Agent', /* @ngInject */ (User, $http, $q, $rootScope, $websocket) => {
		let ws;

		const send = request => {
			if (!ws) {
				return $q.reject('no socket');
			}

			const sendRequest = {
				...request,
				token: $rootScope.context.token.id,
				dsnassokid: $rootScope.context.dsnasso.kid,
				databaseName: $rootScope.context.db.name,
				endpoint: {
					back: $rootScope.context.url.back,
					file: $rootScope.context.url.file,
				},
				host: 'http://localhost:7000',
			};
			return ws.send(angular.toJson(sendRequest));
		};

		const reconnect = async () => {
			ws = $websocket(User.getConfig()?.AGENT?.url);
			ws.onOpen(() => {
				$rootScope.$broadcast('agent:connected');

				send({
					order: 'Auth',
				});
			});

			ws.onClose(error => {
				// ws = null;

				const codes = {
					1005: () => {
						// ws.close();
						// ws = null;
						$rootScope.$broadcast('agent:disconnected');
					},
					1006: () => {
						// ws.close();
						// ws = null;
						$rootScope.$broadcast('agent:disconnected');
					},
					4100: () => {
						// ws.close();
						// ws = null;
						$rootScope.$broadcast('agent:disconnected');
						$rootScope.$broadcast('agent:denied');
					},
				};

				const codeNumbers = Object.keys(codes).map(code => Number.parseInt(code, 10));
				if (codeNumbers.includes(error.code)) {
					codes[error.code]();
				}
				else {
					console.error('Unhandled case!', error.code);
					pRetry(async () => {
						ws = $websocket(User.getConfig().AGENT.url, null);
					}, {
						onFailedAttempt: error_ => {
							console.error(`Attempt ${error_.attemptNumber} failed. There are ${error_.retriesLeft} retries left.`);
						},
					});
				}
			});

			ws.onMessage(message => {
				// eslint-disable-next-line no-console
				console.log('message', message);
			});

			ws.onError(error_ => {
				// console.log('websocket error', e);
				$rootScope.$broadcast('agent:error', error_);
				console.error(error_);
			});
		};

		reconnect();

		$rootScope.$on('User.login', () => {
			reconnect();
		});

		$rootScope.$on('User.logout', () => {
			if (ws && ws.bufferedAmount) {
				ws.close();
			}
		});

		return {
			/**
			 * @param {string} nodeid
			 * @param readOnly
			 */
			openFile(nodeid, readOnly = false) {
				send({
					order: 'openFile',
					nodeid,
					readOnly,
				});
			},
			/**
			 */
			connect() {
				reconnect();
			},
			status: 'disconnected',
		};
	});
